<template lang="pug">
  div
    v-container.ma-0(style="width=100%;")
      v-row.pa-0
        v-col.pa-0(cols="8")
          div.font-weight-bold.mb-0.body-2.black--text(style="cursor: pointer;" @click="clickOpenReceipt()")
            h6.s1.primary500--text #
              span.s1.primary500--text {{ getReceiptId() }}
        v-col.pa-0.pl-4.text-right(cols="4")
          v-chip(small outlined rounded class="text-uppercase my-auto button-AA-tiny" :color="bill.paid ? 'success500': 'danger500'" :style="{ 'background-color': chipBackgroundColor(bill.paid) + '!important' }") {{ bill.paid ? 'SUCCESS': 'FAILED'}}
      v-row.mt-4.pa-0
          v-col.pa-0(cols="8")
            p.mb-0.c1.primary500--text {{ $t('amount') }}: 
              span {{ bill.total_amount | displayPrice($currency) }}
            p.mb-0.c1.primary500--text(v-if="bill.paid && bill.paid_at") {{ bill.paid_at | convertServerDate }}
          v-col.pa-0.text-right(cols="4")
            v-btn.button-Aa-small(x-small text color="primary400" @click="clickOpenReceipt()")
              eva-icon.mr-2.mt-1(name="file-text-outline" width="15" height="15" :fill="$vuetify.theme.themes[$theme].primary400")
              template(v-if="bill.paid")
                | {{ $t('view_receipt') }}
              template(v-else)
                | {{ $t('view_invoice') }}
    .modals
      bill-invoice(v-if="openInvoiceDialog" :open.sync="openInvoiceDialog" :bill.sync="bill" :company="company")

</template>

<script>
import BillInvoice from '@/components/dialogs/BillInvoice.vue'

export default {
  name: 'BillItem',
  props: ['bill', 'index', 'company'],
  components: { BillInvoice },
  data: () => ({
    lead: null,
    openInvoiceDialog: false
  }),
  methods: {
    getReceiptId () {
      return this.bill.bill_no
    },
    clickOpenReceipt() {
      this.openInvoiceDialog = true
    },
    chipBackgroundColor (paid) {
      const theme = this.$vuetify.theme.themes[this.$theme]
      return paid ? theme.successT08 : theme.dangerT08
    }
}
}
</script>

<style scoped>
.bill-card{
  border:0px solid var(--v-basic300);
  border-radius: 0;
  border-top:4px solid var(--v-primary200);
}
</style>
